import { ref, reactive } from 'vue'

// Shared state for filters
export const state = {
  // Tracks which menu is currently open
  openMenu: ref(null),
  
  // Store the last search query
  lastSearchQuery: ref(''),
  
  // Tracks if there is an active search cooldown
  searchCooldown: ref(false),
  
  // Store for selected sort options
  selectedSort: ref(null),
  
  // Store for selected filter options (grouped by filter ID)
  selectedFilters: reactive({}),
}
